var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWritingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E2FEFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19184_96710",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19184_96710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 26.3333L16.2083 22.7917L17.375 21.625L19.75 24L24.4583 19.2917L25.625 20.4583L19.75 26.3333ZM10.5 21.3333L14.5417 10.5H16.5L20.5417 21.3333H18.625L17.6667 18.5833H13.2917L12.3333 21.3333H10.5ZM13.875 17H17.125L15.5417 12.5H15.4583L13.875 17Z",
    fill: "#12B6BC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingIcon);
export default __webpack_public_path__ + "static/media/writing-icon.987fec1fee3cc0a59ca522bd4cc7f762.svg";
export { ForwardRef as ReactComponent };